var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankNote01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 9.16732V12.5006M15.3333 7.50065V10.834M14.5 3.33398C16.5406 3.33398 17.6443 3.64628 18.1934 3.88852C18.2666 3.92078 18.3031 3.93691 18.4087 4.03763C18.4719 4.098 18.5874 4.27515 18.6171 4.35739C18.6667 4.4946 18.6667 4.5696 18.6667 4.7196V13.6766C18.6667 14.4339 18.6667 14.8126 18.5531 15.0072C18.4376 15.2052 18.3262 15.2972 18.11 15.3733C17.8974 15.4481 17.4683 15.3657 16.6101 15.2008C16.0095 15.0854 15.2971 15.0007 14.5 15.0007C12 15.0007 9.5 16.6673 6.16667 16.6673C4.12608 16.6673 3.02239 16.355 2.47324 16.1128C2.4001 16.0805 2.36354 16.0644 2.258 15.9637C2.19474 15.9033 2.07926 15.7262 2.04956 15.6439C2 15.5067 2 15.4317 2 15.2817L2 6.3247C2 5.56739 2 5.18874 2.11356 4.9941C2.22908 4.79612 2.34049 4.70408 2.55672 4.62799C2.76928 4.55319 3.19836 4.63564 4.05652 4.80052C4.65718 4.91593 5.36957 5.00065 6.16667 5.00065C8.66667 5.00065 11.1667 3.33398 14.5 3.33398ZM12.4167 10.0007C12.4167 11.1512 11.4839 12.084 10.3333 12.084C9.18274 12.084 8.25 11.1512 8.25 10.0007C8.25 8.85006 9.18274 7.91732 10.3333 7.91732C11.4839 7.91732 12.4167 8.85006 12.4167 10.0007Z",
    stroke: "#667085",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankNote01);
export default __webpack_public_path__ + "b77fc82df6fb5cad19b66aaab1a6de4d.svg";
export { ForwardRef as ReactComponent };